module.exports = __webpack_public_path__ + "static/media/facebookIcon.d651082e.png";